import script from "./NewUserWelfare2.vue?vue&type=script&setup=true&lang=js"
export * from "./NewUserWelfare2.vue?vue&type=script&setup=true&lang=js"

import "./NewUserWelfare2.vue?vue&type=style&index=0&id=3ffa709f&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ffa709f"]])

export default __exports__